<template>
  <div v-if="dashboard_actions_priority.length && priorityAction2s.length" class="form-v1">
    <v-layout wrap>
      <v-flex md6>
        <h2>
          Hallazgos ({{filteredRows.length}})
        </h2>
      </v-flex>
      <v-flex xs12 md3 style="text-align: end;">
        <a v-if="myPermissions.includes(17)"
          :disabled="!link"
          :href="link"
          target="_blank"
          style="text-decoration: none;">
          <v-btn color="secondary" :disabled="!link" :style="dark_t?'color:black':''">
            <v-icon></v-icon>
            <span>Exportar Excel</span>
          </v-btn>
        </a>
        <!-- <v-btn color="secondary"  @click="exportExcel" v-if="myPermissions.includes(17)" :style="dark_t?'color:black':''">
          <v-icon></v-icon>
          <span>Exportar Excel</span>
        </v-btn> -->
      </v-flex>
      <v-flex md3 style="text-align: end;">
        <label for="file-upload-actions" class="custom-file-upload textAlignCenter fullWidth" v-if="myPermissions.includes(15)">
          <v-icon>attach_file</v-icon>
          <fs1-span> Cargar Hallazgos</fs1-span>
          <input id="file-upload-actions" class="btn" type="file" @change="selectFile($event.target.files)">
        </label>
        <fs1-div>Fecha de última carga: {{formalDateFormat(sheet_update)}}</fs1-div>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex md8>
        <v-layout>
          <v-flex md4 px-4>
            <v-autocomplete
              v-model="filtersOrganization"
              :items="organizations"
              hide-details
              clearable
              :item-text="(i) => `${i.name}`"
              item-value="name"
              label=" Área"/>
          </v-flex>
          <v-flex md4 px-4>
            <debounce-select-old
              v-if="ie11"
              st_key="actions"
              item_key="critical_asset_name"
              label="Activos Criticos"
              append_icon="search"
              :value.sync="filters.critical_asset_name"/>
            <v-combobox
              v-else
              clearable
              label=" Activos Criticos"
              :items="f_actions"
              hide-details
              append-icon="search"
              :item-text="(i) => `${i.critical_asset_name}`"
              :search-input.sync="filters.critical_asset_name"
              hide-no-data
              hide-selected/>
          </v-flex>
          <v-flex md4 px-4>
            <v-text-field v-model="filters.responsible_area" append-icon="search" label=" Area Responsable" clearable/>
          </v-flex>
        </v-layout>
        <v-layout mt-4>
          <v-flex md4 px-4>
            <v-text-field v-model="filters.functional_location" append-icon="search" label=" Functional location" clearable/>
          </v-flex>
          <v-flex md4 px-4>
            <v-select label=" Estatus de Remediación" v-model="filters.remediation_status" :items="remediation_status" multiple/>
          </v-flex>
          <v-flex md4 px-4>
            <in-combobox
              label=" Código"
              :items="rows"
              i_text="finding_code"
              :value.sync="filters.finding_code"/>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex md4 style="padding-top: 0 !important;">
        <v-layout>
          <v-flex px-4>
            <div style="text-align: center;">
              <span class="label">Priority:</span>
              <fs1-tooltip>
                <ul>
                  <li>P1 (900-3000) = Detener la operación hasta que se rectifique el defecto / operación continua solo con aprobación de GM</li>
                  <li>P2 (300) = Definido a nivel de activo a través del estándar de Nivel de activo (No debe exceder 1 año *)</li>
                  <li>P3 (90-100) = Definido a nivel de activo a través del estándar de Nivel de activo</li>
                  <li>P4 (30) = Monitoreo a través de inspecciones rutinarias de AIMS (P3 emergente - Considere monitoreo adicional)</li>
                  <li>P5 (0.3-10) = Monitor a través de inspecciones rutinarias de AIMS</li>
                </ul>
              </fs1-tooltip>
              <ul class="statusFilter mt-2">
                <li
                  v-for="(item, i) in priorities"
                  :key="i"
                  :style="selectedPriority.find(i => i === item) ? `background-color:${psColors[i]}; color: ${psFontColors[i]}`: (`color:${dark_t?'white':'black'}`)"
                  :class="selectedPriority.find(i => i === item) && `selected`"
                  @click="toggleItems(selectedPriority, item)">
                  {{item}}
                </li>
              </ul>
            </div>
          </v-flex>
        </v-layout>
        <v-layout mt-4>
          <v-flex class="text-center" px-4>
            <Doughnut id="dona_actions_1"
              :legendDisplay="false"
              :data.sync="Ps.data"
              :labels="Ps.labels"
              :colors="psColors"
              :onClick="(ev, array) => openModalDoughnut(ev, array)"/>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <Table :data.sync="filteredRows" :colors="tableColors"/>


    <v-dialog v-model="dialog" :width="'90%'">
			<v-card class="fullHeight pa-20">
				<h2>{{selectedTitle}} ({{modalFilteredRows.length}})</h2>
				<br>
				<Table :data.sync="modalFilteredRows" :colors="tableColors"/>
				<div class="textAlignCenter">
					<v-btn @click="dialog = false" color="secondary">
						<fs1-span>Cerrar</fs1-span>
					</v-btn>
				</div>
			</v-card>
    </v-dialog>
  </div>
</template>
<script>
import Bar from '@/components/graphs/Bar.vue';
import Doughnut from '@/components/graphs/Doughnut.vue';
import Table from '@/components/actions/table/Actions.vue';
import { mapGetters } from 'vuex';
import { uploadActions, getExportActions   as exportExcel } from '@/requests/ac';
import { customFilter } from '@/functions/general.js';
import SheetUpdate from '@/components/mixins/SheetUpdate';

export default {
  mixins:[SheetUpdate],
  data() {
    return {
      link:null,
      remediation_status:[],
      sheet_update_key:'actions',
      filterSeverityLevel1: null,
      selectedPriority: [],
      searchPriority: '',
      //selectedPriorityAction2: [],
      searchPriorityAction2: '',
      filtersOrganization: '',
      filters: {
        functional_location:'',
        critical_asset_name: '',
        responsible_area: '',
        remediation_status:[],
        finding_code:[],
      },
      modalFilteredRows: [],
      dialog: false,
      selectedTitle: '',
      priorityGetted:false,
    };
  },
  async created() {
    this.requests.gets['function/get_old_finding_sheet']()
      .then(r => this.link = (r||{}).file)

    this.requests.get['helper/get_all_remediation_status']()
      .then(r => this.remediation_status = r)

    const {dashboard_actions_priority_actions,dashboard_actions_priority} = this;
    //console.log({dashboard_actions_priority_actions,dashboard_actions_priority})
    //this.selectedPriorityAction2 = [...dashboard_actions_priority_actions];
    /* this.selectedPriority = dashboard_actions_priority.map(m => m.priority); */
  }, // created
  watch:{
    /* dashboard_actions_priority_actions(v){
      console.warn({v})
      this.selectedPriorityAction2 = [...v];
    }, */
/*     dashboard_actions_priority(v){
      console.warn({v});
      this.selectedPriority = v.map(m => m.priority);
    }, */
  },
  computed: {
    ...mapGetters({
      organizations: 'organizations',
      accessRequesting: 'accessRequesting',
      actions: 'actions',
    }),
    f_actions() {
      return this.filters.critical_asset_name
        ? this.actions.filter(f => f.critical_asset_name.toLowerCase().includes(this.filters.critical_asset_name.toLowerCase()))
        : this.actions;
    },
    tableColors(){
      const colors = {};
      const findColor = (toF) => (this.dashboard_actions_priority.find(p => p.priority === toF) || {}).background_color;
      this.priorities.forEach((p,i) => colors[p] = findColor(p));
      return colors
    },
    dashboard_actions_priority() {
      
      return this.$store.getters.dashboard_actions_priority },
    dashboard_actions_priority_actions() {return this.$store.getters.dashboard_actions_priority_actions },
    priorityAction2s(){
      const array = [];
      this.dashboard_actions_priority_actions.forEach(e => array.push({name: e, id: e}));
      return array;
    },
    priorities() { 
      const ps = this.dashboard_actions_priority.map(m => m.priority);
      if (this.priorityGetted === false) {
        this.selectedPriority = [...ps];
        this.priorityGetted = true;// no siempre pesca o no lo hace en el watch
      }
      return ps
    },
    //actions() { return this.$store.getters.actions },
    psFontColors(){ return this.dashboard_actions_priority.map(m => m.font_color) },
    psColors(){ return this.dashboard_actions_priority.map(m => m.background_color) },
    Ps() {
      const data = [];
      const labels =  this.priorities;
      const colors = this.psColor;
      //console.log({colors})
      labels.forEach(l => data.push(this.filteredRows.filter(e => e.priority === l).length));
      return {data, colors, labels};
    },
    /* dataBar() {
      const dataBar = {labels: this.dashboard_actions_priority_actions, datasets: []};
      const data = [];
      dataBar.labels.forEach(val => data.push(this.filteredRows.filter(e => val === e.priority_action_2).length))
      const color = this.dark_t? '#4472c4':'#4472c4';
      dataBar.datasets = [
        {
          label: 'Totales',
          data,
          backgroundColor: color,
          borderColor: color,
        },
      ];
      return dataBar;
    }, */
    rows(){ 
      /* this.actions.forEach(r => {
        console.log(r.priority_action_2);
        r.priority_action_2 = (r.priority_action_2 || '').trim()
      }); */
      return this.actions
    },
    filteredRows() {
      /* const filterSeverityLevel1 = parseInt(this.filterSeverityLevel1); */
      const filterPr = this.selectedPriority.length != this.priorities.length;
      //const filterPrAc2 = this.selectedPriorityAction2.length != this.priorityAction2s.length;
      //console.log('E1', this.rows)
      const rows = this.rows.filter(r => {
        /* if (!this.filtersOrganization.includes(r.critical_asset_organization)) {
          return false;
        } */
        //console.log('E2', this.filtersOrganization && this.filtersOrganization != r.critical_asset_organization, this.filtersOrganization , r.critical_asset_organization)
        if (this.filtersOrganization && this.filtersOrganization != r.critical_asset_organization) {
          return false;
        }
        /* console.log('E3', filterSeverityLevel1 || filterSeverityLevel1 === 0,filterSeverityLevel1)
        if(filterSeverityLevel1 || filterSeverityLevel1 === 0) {
          if (r.severity_level_1 !== filterSeverityLevel1) return false;
        } */
        //console.log('E4', filterPr)
        if(filterPr){
          if (!this.selectedPriority.includes(r.priority)) return false;
        }
        //console.log('E5', filterPrAc2)
        /* if(filterPrAc2){
          if (!this.selectedPriorityAction2.includes(r.priority_action_2)) return false;
        } */
        return true;
      })
      //console.log('E6', this.filters)
      return rows.filter(r => customFilter(r, this.filters));
    },
  },
  watch: {
    //'organizations'(v) { this.filtersOrganization = v.map(m => m.name) }
  },
  components: {
    Bar,
    Doughnut,
    Table,
  },
  methods: {
		async exportExcel(){
      this.setProgress({show:true,message:'Cargando...'});
      if(!await this.assignAccess()) return;
      const filters = {...this.filters};
      const {filtersOrganization,selectedPriorityAction2,selectedPriority} = this;
      Object.assign(filters,{filtersOrganization}/* ,{selectedPriorityAction2} */,{selectedPriority})
			exportExcel(filters)
        .then(r => this.setProgress({show:false}))
        .catch(e => this.getError(e));
		},
    async selectFile(files) { // files no es un array por lo que sus proto funciones no aplican
      if(!await this.assignAccess()) return;
      if(files.length === 0) return;
      //console.log(uploadActions, 'ASADSADSADSADSADSADA')
      this.setProgress({message:'Guardando...',show:true});
      uploadActions({file:files[0]})
        .then(r => {
          console.warn(r)
          this.setProgress({show:false});
          (r.message || '').toLowerCase() === 'success'
            ? this.setSnackbar({message: 'Guardado.', class: 'success'}) || this.reGetSheetUpdate()
            : this.setSnackbar({message: 'Problema.', class: 'error'});
        })
        .catch(e => this.getError(e));
		},
  
    toggleItems(items, item) {
      items.find(i => i === item)
        ? items.splice(items.indexOf(item), 1)
        : items.push(item);
    },
    /* openModalBar(ev, array) {
      //console.log({ev,array},this.dataBar.datasets)
      if (array.length === 1) {
        //console.log(array[0]._index,array[0]._model.label)
        this.modalFilteredRows = this.rows.filter(e => e.priority_action_2 === array[0]._model.label);
        this.selectedTitle = array[0]._model.label;
        this.dialog = true;
      } // if
    }, */
    openModalDoughnut(ev, array) {
      if (array.length === 1) {
        //console.log(array[0]._model.label)
        this.modalFilteredRows = this.rows.filter(e => e.priority === array[0]._model.label);
        this.selectedTitle = array[0]._model.label;
        this.dialog = true;
      } // if
    },
  },
};
</script>

<style scoped>
  .label {
    color:grey;
  }
  .statusFilter{
    list-style: none;
    padding: 0;
  }
  .statusFilter > li{
    text-decoration: line-through;
    cursor: pointer;
    border-radius: 3px;
    background-color: none;
    color: black;
    display: inline;
    padding: 4px 14px 4px 14px;
    margin-right: 5px;
  }
  .statusFilter > li.selected{
    color: white;
    text-decoration: none;
  }
  .statusFilter > li.selected.InProgress{ background-color: #d99148; }
  .statusFilter > li.selected.NotCommenced{ background-color: #aaaaaa; }
  .statusFilter > li.selected.Completed{ background-color: #454444; }

</style>
